/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import PropTypes from 'prop-types';

function Cell({ cell, addValueToQuery, className }) {
  return (
    <div className={className}>
      {cell && cell.name && (
        <span
          onClick={() => addValueToQuery(cell)}
          className={`rx-period-table-element rx-periodic-element-${cell.type || ''}`}
          role="button"
          tabIndex="0">
          {cell.name}
        </span>
      )}
    </div>
  );
}

Cell.defaultProps = {
  addValueToQuery: () => {},
  cell: null,
  className: '',
};
Cell.propTypes = {
  addValueToQuery: PropTypes.func,
  cell: PropTypes.object,
  className: PropTypes.string,
};

export default Cell;
